





























































import Vue from "vue";
import storeHelper from "../../../store/store-helper";
import Shared from "../../../shared";
import Utils from "../../../utils";
import { cookies } from "../../../enums";
import UserAvatar from "../../buttons/UserAvatar.vue";
import jwtDecode from "jwt-decode";

const allow_saml2_logoff = "allow_saml2_logoff";

export default Vue.extend({
    name: "UserMenu",
    components: { UserAvatar },
    props: {
        openPrivacy: { type: Function, required: true },
        portalId: Number
    },
    data: function () {
        return {
            availableApps: null,
            showLogoff: false
        };
    },
    async created() {
        await this.getShowLogoff();
        await storeHelper.appsStore.loadApps();
        this.availableApps = storeHelper.appsStore.apps.length;
    },
    computed: {
        isInternetExplorer(): Boolean {
            return Utils.isIE11;
        },
        isAnonymousUser(): Boolean {
            return Utils.isAnonymousUser(this.$user.user_id);
        },
        isAdministrator(): Boolean {
            return Utils.isAdministrator(this.$user.user_id);
        },
        userFullName(): string {
            return this.$user?.name;
        },
        userLoginCode(): string {
            return this.$user?.login_code;
        },
        isAutoLogon(): boolean {
            const bearerToken = Utils.getCookie("Authorization");
            //Make sure user is authenticated
            if (bearerToken != null) {
                //Decode the bearer token
                const decodedToken: any = jwtDecode(bearerToken);
                //Check autoLogon is set to 1
                if (decodedToken.AutoLogin === "1") return true;
            }

            return false;
        },
        showMySettings(): boolean {
            return this.$user.show_preferences;
        },
        showMySubscriptions(): boolean {
            return this.$user.show_tasks_and_subscriptions;
        }
    },
    methods: {
        async getShowLogoff(): Promise<void> {
            // shortcut when not autologon
            if (!this.isAutoLogon) {
                this.showLogoff = true;
                return;
            }
            this.showLogoff = await storeHelper.settingsStore.getSettingAsync<boolean>(allow_saml2_logoff);
        },
        privacyClicked() {
            this.openPrivacy();
        },
        optionWasClicked() {
            //here will be the code handling the options click event
        },

        logOnClicked() {
            Utils.navigateToLogin();
        },
        logoffClicked() {
            location.href = `${Shared.iProvaUrl}/Management/Login/Logoff.aspx`;
        },
        logOnAsDifferentUserClicked() {
            Utils.setCookie(cookies.iProva_LoginRedirect, location.href);
            location.href = `${Shared.iProvaUrl}/Login?asdifferentuser=1`;
        }
    }
});
